import { render, staticRenderFns } from "./ViewGroupEmailHistoryStats.vue?vue&type=template&id=20959fad&scoped=true&"
import script from "./ViewGroupEmailHistoryStats.vue?vue&type=script&lang=ts&"
export * from "./ViewGroupEmailHistoryStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20959fad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
